import { EventEmitter, Injectable, ViewChild } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { HubConnection } from '@aspnet/signalr';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../modals/delete-modal/delete-modal.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  @ViewChild('content', { static: false }) myModal: any;
  Reason: any;
  private hubConnection: HubConnection;
  user: any;
  modalRef: NgbModalRef;
  private roleLogoutPromptOpen = false;
  newMsgUpdate: EventEmitter<any> = new EventEmitter();
  logoutUpdate: EventEmitter<any> = new EventEmitter();

  constructor(
    public readonly router: Router,
    private readonly apiService: ApiService,
    private readonly toastrService: ToastrService,
    public readonly commonService: CommonService,
    private readonly storageService: StorageService,
    private readonly modalService: NgbModal
  ) {}

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Debug)
      .withUrl(environment.signalR_url, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.user = JSON.parse(this.storageService.get('userDetail'));
        if (this.user.userId) {
          this.hubConnection
            .invoke('AssignConnectionIdAsync', this.user.userId, this.user.role)
            .then((res) => {
              if (res.data) {
                sessionStorage.setItem('connectionId', res.data);
                this.messageEventListner();
              }
            });
        }
      })
      .catch((err) => {});

    this.hubConnection.on('error', function (err) {});

    this.hubConnection.onclose((error) => {
      if (this.storageService.get('userDetail')) {
        this.hubConnection
          .start()
          .then(() => {
            if (!sessionStorage.getItem('connectionId')) {
              this.hubConnection
                .invoke(
                  'AssignConnectionIdAsync',
                  this.user.userId,
                  this.user.role
                )
                .then((res) => {
                  sessionStorage.setItem('connectionId', res.data);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };


  messageEventListner() {
  this.hubConnection.on(
    'OnMessageSend',
    (title: string, body: string, type: string, extraDataJson: string) => {

      if (!title) return;

      const infoMessageTypes = [
        'Appointment-Scheduled',
        'Appointment-Rescheduled',
        'Appointment-Cancelled',
        'Patient-Assigned'
      ];

      const silentTypes = [
        'new-chat-message',
        'User-Login',
        'User-Logout'
      ];

      if (infoMessageTypes.includes(type)) {
        this.toastrService.info('New Message Received');
      }

      if (type === 'Patient-Checkin') {
        this.toastrService.info(body, '', { timeOut: 5000 });
      }

      if (type === 'logout' || this.isRoleUpdateNotice(type, title, body)) {
        if (this.isAccountDeactivation(title, body)) {
          this.toastrService.info('Your Account is Deleted or deactivated');
          this.storageService.clear();
          localStorage.clear();
          this.router.navigate(['/login']);
        } else {
          this.promptRoleModificationLogout();
        }
      }

      if (infoMessageTypes.includes(type) || 
          silentTypes.includes(type) || 
          type === 'Patient-Checkin' || 
          type === 'logout') {
        this.commonService.emitnewMsgUpdateEvent(extraDataJson);
      }
    }
  );
}

  private isRoleUpdateNotice(type: string, title: string, body: string): boolean {
    const text = `${type || ''} ${title || ''} ${body || ''}`.toLowerCase();
    return text.includes('role') || text.includes('permission');
  }

  private isAccountDeactivation(title: string, body: string): boolean {
    const text = `${title || ''} ${body || ''}`.toLowerCase();
    return /delet|deactiv|inactive|disabled/.test(text) && !/role|permission/.test(text);
  }

  private promptRoleModificationLogout(): void {
    if (this.roleLogoutPromptOpen) {
      return;
    }
    this.roleLogoutPromptOpen = true;
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'md',
    });
    this.modalRef.componentInstance.modalData = {
      title: 'Role Modified',
      des: 'Your role has been modified. Please log out.',
      classConfirmButton: 'btn-primary',
      confirmButtonText: 'OK',
      showCancelButton: false,
    };
    this.modalRef.result
      .then((res) => {
        this.roleLogoutPromptOpen = false;
        if (res?.status === 1) {
          this.storageService.clear();
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/login']);
        }
      })
      .catch(() => {
        this.roleLogoutPromptOpen = false;
      });
  }

  handleNotificationClick(notif) {
    this.apiService
      .updateRequest('notification', {
        notificationId: notif?.notificationId,
        toUserId: notif?.toUserId,
        isRead: true,
      })
      .subscribe((res) => {
        if (res.status) {
          notif?.type == 'patient-messaged'
            ? this.router.navigate(['therapist/chats'])
            : this.router.navigate(['patient/chats']);
        }
      });
  }

  closeConnection() {
   this.hubConnection?.stop();
  }
}
